export const STAFF_SEARCH_LOCATION_COOKIE_NAME = 'staff-search-location';
